import { MAX_TIMEOUT_MS } from './prewarm/with-timeout.mjs';

export function mergeFpOptions(defaults, overrides) {
  const fp = Object.assign({}, defaults);
  const src = overrides && typeof overrides === 'object' ? overrides : {};
  for (const key in src) {
    if (Object.prototype.hasOwnProperty.call(src, key) && src[key] !== undefined) fp[key] = src[key];
  }
  return fp;
}

export function triState(value) {
  if (value === true || value === 'on') return true;
  if (value === false || value === 'off') return false;
  return null;
}

export function resolveProducts(options) {
  const o = options && typeof options === 'object' ? options : {};
  return { fp: productEnabled(o.fp), di: productEnabled(o.di) };
}

function productEnabled(value) {
  if (!value || typeof value !== 'object') return true;
  return value.enabled !== false;
}

export const SDK_MODE = { LEGACY: 'legacy', DEFAULT: 'default' };

const AUTO_COLLECT_DELAY_MS = 1000;

export function isSdkMode(value) {
  return value === SDK_MODE.LEGACY || value === SDK_MODE.DEFAULT;
}

export function resolveMode(options) {
  const o = options && typeof options === 'object' ? options : {};
  return o.mode === SDK_MODE.DEFAULT ? SDK_MODE.DEFAULT : SDK_MODE.LEGACY;
}

export function resolveAutoCollect(options) {
  const o = options && typeof options === 'object' ? options : {};
  const c = o.collect && typeof o.collect === 'object' ? o.collect : {};
  const delay = asNumber(c.delay);
  return {
    auto: c.auto !== false,
    delayMs:
      delay !== null && Number.isFinite(delay) && delay >= 0 ? Math.min(delay, MAX_TIMEOUT_MS) : AUTO_COLLECT_DELAY_MS,
  };
}

export function resolveStorageTimeoutMs(fp, chromiumAndroid, androidDefaultMs) {
  const v = asNumber(fp ? fp.storageTimeoutMs : undefined);
  if (v !== null) {
    if (!Number.isFinite(v) || v > MAX_TIMEOUT_MS) return 0;
    return v > 0 ? v : 0;
  }
  if (!chromiumAndroid) return 0;
  const d = asNumber(androidDefaultMs);
  return d !== null && Number.isFinite(d) && d > 0 ? Math.min(d, MAX_TIMEOUT_MS) : 0;
}

function asNumber(v) {
  if (typeof v === 'number') return v;
  if (typeof v === 'string' && v.trim() !== '') {
    const n = Number(v);
    return Number.isNaN(n) ? null : n;
  }
  return null;
}
